import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-server",
  "use": "icon-server-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-server\"><defs><style type=\"text/css\"></style></defs><path d=\"M890 120H134a70 70 0 0 0-70 70v500a70 70 0 0 0 70 70h756a70 70 0 0 0 70-70V190a70 70 0 0 0-70-70z m-10 520a40 40 0 0 1-40 40H712V448a40 40 0 0 0-80 0v232h-80V368a40 40 0 0 0-80 0v312h-80V512a40 40 0 0 0-80 0v168H184a40 40 0 0 1-40-40V240a40 40 0 0 1 40-40h656a40 40 0 0 1 40 40zM696 824H328a40 40 0 0 0 0 80h368a40 40 0 0 0 0-80z\" fill=\"#bfbfbf\" p-id=\"6718\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/server.svg
// module id = 2Sb8
// module chunks = 138